import { render, staticRenderFns } from "./resetPasswordSub.vue?vue&type=template&id=3fdb7f0e&lang=pug&"
import script from "./resetPasswordSub.vue?vue&type=script&lang=js&"
export * from "./resetPasswordSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports